import { FolderTemplateModel } from "./folder-template.model";

export class AddOrEditFolderTemplateModel extends FolderTemplateModel {
  // id: number;
  // name: string;
  public accessGroupId: number;
  public defaultNote: string;
  public caseTypeIds: number[];
}
